export default "__VITE_ASSET__VeKfulQB__"